module.exports = __webpack_public_path__ + "img/22.6.CODm.0e083358.png";